import { CardHeader } from "@verde/compose-ui";
import { useFetchCreditsCostPerConsult } from "@verde/entities";
import {
  AlertCircleIcon,
  ClockIcon,
  ExternalLinkIcon,
  LockClosedIcon,
} from "@verde/icons";
import { Alert, Button } from "@verde/ui-core";
import { formatDate } from "@verde/utils";
import React, { Fragment } from "react";
import { useCreditProfilePanel } from "./panel";

function PanelStatus() {
  const { mode, resource, client, consentment, handleUnlock } =
    useCreditProfilePanel();
  const costs = useFetchCreditsCostPerConsult();

  if (mode !== "anchor" && resource.available) return null;

  return (
    <div className="overflow-hidden rounded">
      <img
        alt=""
        src="/static/credit-profile/demo-v1.png"
        className="h-[240px] w-full object-cover"
      />

      <div className="grid gap-6 rounded-b border border-neutral-light-2 bg-neutral-light-pure p-6 pb-9">
        {mode === "anchor" && !resource.available && (
          <>
            <CardHeader
              title="Como ver os dados do endividamento do produtor?"
              icon={<LockClosedIcon />}
            />

            <div className="-mt-3 block h-1 w-[56px] rounded-full bg-brand-yellow" />
          </>
        )}

        {mode === "anchor" && (
          <>
            {resource.available === false && (
              <div className="-mt-2 rounded bg-neutral-light-1 p-4">
                {[
                  {
                    title:
                      'Obtenha a autorização do produtor para consultar seus dados. Selecione "Desbloquear acesso".',
                  },
                  {
                    title: "Utilize os créditos para poder consultar dados.",
                  },
                ].map(({ title }, index, items) => {
                  return (
                    <Fragment key={`unlock-faq-item-${title}`}>
                      <p className="flex items-center gap-2 text-lg font-semibold text-neutral-dark-2">
                        {index + 1}º - {title}
                      </p>

                      {index !== items.length - 1 && (
                        <hr className="my-4 h-[2px] bg-neutral-light-2" />
                      )}
                    </Fragment>
                  );
                })}
              </div>
            )}

            {resource.available === true && (
              <Alert
                classNames={{
                  base: "p-4",
                  content: "flex justify-between",
                }}
              >
                <p className="flex items-center gap-1 text-lg font-semibold">
                  <ClockIcon className="h-5 w-5" />
                  Ultima consulta de dados:
                </p>

                <p className="text-lg font-semibold">
                  {formatDate(client?.last_x_ray_at)}
                </p>
              </Alert>
            )}
          </>
        )}

        {mode !== "anchor" &&
          (resource.authorized ? (
            <Alert size="lg">
              1 consulta ou atualização de dados = {costs.data?.[0]?.value}{" "}
              créditos
            </Alert>
          ) : (
            <>
              {consentment && (
                <Alert
                  size="lg"
                  classNames={{
                    base:
                      consentment?.status === "rejected"
                        ? "bg-off-red"
                        : "bg-off-yellow-bg",
                  }}
                >
                  <div className="flex items-center gap-4">
                    <AlertCircleIcon className="h-6 w-6 text-neutral-dark-1" />
                    {}
                    {consentment?.channel === "attachment" &&
                      `Obtenha a autorização do produtor para consultar seus dados. Selecione "Desbloquear acesso".`}

                    {consentment?.channel === "whatsapp" && (
                      <div className="grid gap-2">
                        <p className="text-lg font-semibold">
                          {consentment.status === "rejected"
                            ? "Autorização rejeitada pelo produtor"
                            : `Autorização para consulta dos dados solicitada por Whatsapp em ${formatDate(consentment?.created_at)}`}
                        </p>
                        <p className="font-medium">
                          Recomendamos entrar em contato com seu cliente para
                          garantir que faça a autorização da consulta.
                        </p>
                      </div>
                    )}
                  </div>
                </Alert>
              )}

              {!consentment && (
                <Alert size="lg">
                  Obtenha a autorização do produtor para consultar seus dados.
                  Selecione "Desbloquear acesso".
                </Alert>
              )}
            </>
          ))}

        <Button
          size="lg"
          onClick={handleUnlock}
          icon={resource.available ? <ExternalLinkIcon /> : <LockClosedIcon />}
        >
          {mode !== "anchor" && resource.authorized
            ? "Usar crédito e consultar"
            : resource.available
              ? "Ver dados do Raio-X rural"
              : "Desbloquear acesso"}
        </Button>
      </div>
    </div>
  );
}

export default React.memo(PanelStatus);
